(function(){
  if(window.GLaser)return;
  /* ---------- deterministic random + value noise ---------- */
  function rnd(seed){var s=seed>>>0||1;return function(){s^=s<<13;s>>>=0;s^=s>>>17;s^=s<<5;s>>>=0;return s/4294967296;};}
  function noise(w,h,scale,seed){
    var r=rnd(seed*7919+13),gw=Math.max(2,Math.ceil(w/scale))+2,gh=Math.max(2,Math.ceil(h/scale))+2,g=new Float32Array(gw*gh),i,x,y;
    for(i=0;i<g.length;i++)g[i]=r();
    var out=new Float32Array(w*h),k=0;
    for(y=0;y<h;y++){var fy=y/scale,iy=fy|0,ty=fy-iy;ty=ty*ty*(3-2*ty);
      for(x=0;x<w;x++){var fx=x/scale,ix=fx|0,tx=fx-ix;tx=tx*tx*(3-2*tx);
        var a=g[iy*gw+ix],b=g[iy*gw+ix+1],c=g[(iy+1)*gw+ix],d=g[(iy+1)*gw+ix+1];
        out[k++]=(a+(b-a)*tx)+((c+(d-c)*tx)-(a+(b-a)*tx))*ty;}}
    return out;
  }
  function blur(src,w,h,rad){ /* 2-pass separable box blur x2 ~ gaussian */
    var a=new Float32Array(src),b=new Float32Array(w*h),p,x,y,acc,r=Math.max(1,Math.round(rad)),n=2*r+1;
    for(p=0;p<2;p++){
      for(y=0;y<h;y++){acc=0;var row=y*w;for(x=-r;x<=r;x++)acc+=a[row+Math.min(w-1,Math.max(0,x))];
        for(x=0;x<w;x++){b[row+x]=acc/n;acc+=a[row+Math.min(w-1,x+r+1)]-a[row+Math.max(0,x-r)];}}
      for(x=0;x<w;x++){acc=0;for(y=-r;y<=r;y++)acc+=b[Math.min(h-1,Math.max(0,y))*w+x];
        for(y=0;y<h;y++){a[y*w+x]=acc/n;acc+=b[Math.min(h-1,y+r+1)*w+x]-b[Math.max(0,y-r)*w+x];}}
    }
    return a;
  }
  /* ---------- procedural straight-grain wood ---------- */
  function wood(w,h,o){
    o=o||{};var seed=o.seed||1,L=o.light||[226,186,136],D=o.dark||[168,112,64],rings=o.rings||34,s1=w/470;
    var n1=noise(w,h,260*s1,seed),n2=noise(w,h,70*s1,seed+1),n3=noise(w,h,6*s1,seed+2),tone=noise(w,h,420*s1,seed+3);
    var fibH=Math.max(2,Math.round(h/26)),fr=rnd(seed+77),fg=new Float32Array(w*fibH),i;
    for(i=0;i<fg.length;i++)fg[i]=fr();
    var data=new Uint8ClampedArray(w*h*4),k=0,x,y,TP=Math.PI*2;
    for(y=0;y<h;y++){var fy=y/h*(fibH-1),iy=fy|0,ty=fy-iy,iy2=Math.min(fibH-1,iy+1),sy=Math.sin(y/h*Math.PI*1.3+seed)*.35,gy=1.03-.08*(y/h);
      for(x=0;x<w;x++,k++){
        var u=(x/w)*rings+(n1[k]-.5)*2.4+(n2[k]-.5)*.45+sy,s=.5+.5*Math.sin(u*TP);
        var s2=s*s,s4=s2*s2,late=s4*s2*s,early=Math.pow(s,1.6);
        var fib=fg[iy*w+x]*(1-ty)+fg[iy2*w+x]*ty;
        var t=late*.55+early*.18+(fib-.5)*.22+(n3[k]-.5)*.08+(tone[k]-.5)*.35+.18;t=t<0?0:t>1?1:t;
        var g=gy-.05*Math.abs(x/w-.45),j=k*4;
        data[j]=(L[0]*(1-t)+D[0]*t)*g;data[j+1]=(L[1]*(1-t)+D[1]*t)*g;data[j+2]=(L[2]*(1-t)+D[2]*t)*g;data[j+3]=255;}}
    return {w:w,h:h,data:data};
  }
  /* ---------- laser burn ---------- */
  function engrave(base,mask,depth){
    var w=base.w,h=base.h,out=new Uint8ClampedArray(base.data),s=w/470;
    depth=depth||.86;
    var halo=blur(mask,w,h,2.2*s*1.4),sh=blur(mask,w,h,Math.max(1,1.1*s*1.4)),tex=noise(w,h,3*s,99),off=Math.max(1,Math.round(2*s)),k,j;
    for(k=0;k<w*h;k++){
      var m=mask[k],hl=halo[k];if(m<.003&&hl<.003)continue;
      var y=(k/w)|0,up=y>=off?sh[k-off*w]:0,dn=y<h-off?sh[k+off*w]:0;
      var kk=m*depth*(tex[k]*.25+.75)+hl*.10;kk=kk>1?1:kk;j=k*4;
      var el=dn-up>0?dn-up:0,ed=up-dn>0?up-dn:0;
      out[j]=out[j]*(1-kk)+(out[j]*.35+52*.65)*kk+el*26-ed*18;
      out[j+1]=out[j+1]*(1-kk)+(out[j+1]*.35+28*.65)*kk+el*26-ed*18;
      out[j+2]=out[j+2]*(1-kk)+(out[j+2]*.35+12*.65)*kk+el*26-ed*18;}
    return {w:w,h:h,data:out};
  }
  function toCanvas(img){var c=document.createElement('canvas');c.width=img.w;c.height=img.h;c.getContext('2d').putImageData(new ImageData(img.data,img.w,img.h),0,0);return c;}
  function maskCanvas(w,h,draw){var c=document.createElement('canvas');c.width=w;c.height=h;var x=c.getContext('2d');x.fillStyle='#000';x.fillRect(0,0,w,h);x.fillStyle='#fff';x.strokeStyle='#fff';x.lineJoin='round';x.lineCap='round';draw(x,w,h);
    var d=x.getImageData(0,0,w,h).data,m=new Float32Array(w*h);for(var i=0;i<m.length;i++)m[i]=d[i*4]/255;return m;}
  function rr(x,X,Y,W,H,R){x.beginPath();x.moveTo(X+R,Y);x.arcTo(X+W,Y,X+W,Y+H,R);x.arcTo(X+W,Y+H,X,Y+H,R);x.arcTo(X,Y+H,X,Y,R);x.arcTo(X,Y,X+W,Y,R);x.closePath();}
  var SERIF='italic 400 {s}px Georgia,"Times New Roman",serif',SERIF_R='400 {s}px Georgia,"Times New Roman",serif';
  function font(tpl,s){return tpl.replace('{s}',Math.round(s));}
  /* ---------- designs ---------- */
  var WP={T:[-.30,-.06],O:[-.42,.36],I:[-.13,.22],C0:[0,.26],F:[-.12,.40],C1:[0,.42],E:[-.21,.51],B:[-.07,.60],K:[-.47,.66],M:[-.14,.82],C2:[0,.66],N:[0,.90],J:[-.27,.92],CH:[0,1.10]};
  var WT=[['T','O','I',.55],['I','C0','F',.30],['O','I','F',.42],['C0','F','C1',.22],['O','F','E',.48],['F','C1','B',.28],['F','B','E',.36],['O','E','K',.62],['E','B','M',.40],['K','E','M',.52],['C1','B','C2',.20],['B','C2','N',.26],['B','N','M',.34],['K','M','J',.58],['M','N','CH',.30],['J','M','CH',.46]];
  function wolf(x,cx,cy,s,st){
    function pt(k,g){return [cx+WP[k][0]*g*s,cy+(WP[k][1]-.5)*s];}
    [1,-1].forEach(function(g){
      WT.forEach(function(t){var a=pt(t[0],g),b=pt(t[1],g),c=pt(t[2],g);x.beginPath();x.moveTo(a[0],a[1]);x.lineTo(b[0],b[1]);x.lineTo(c[0],c[1]);x.closePath();x.globalAlpha=t[3]*.8;x.fill();});
      x.globalAlpha=1;x.lineWidth=st;
      WT.forEach(function(t){var a=pt(t[0],g),b=pt(t[1],g),c=pt(t[2],g);x.beginPath();x.moveTo(a[0],a[1]);x.lineTo(b[0],b[1]);x.lineTo(c[0],c[1]);x.closePath();x.stroke();});
      var e=pt('E',g);x.beginPath();x.moveTo(e[0]-.045*s*g,e[1]+.005*s);x.lineTo(e[0]+.035*s*g,e[1]-.03*s);x.lineTo(e[0]+.05*s*g,e[1]+.02*s);x.closePath();x.fill();
    });
    var n=pt('N',1);x.beginPath();x.moveTo(n[0]-.07*s,n[1]-.03*s);x.lineTo(n[0]+.07*s,n[1]-.03*s);x.lineTo(n[0],n[1]+.045*s);x.closePath();x.fill();
  }
  function wave(x,x0,y0,w,h,st,seed){
    var r=rnd(seed||5),k,i;x.lineWidth=st;
    for(k=0;k<7;k++){x.beginPath();var off=k*h*.075;
      for(i=0;i<=160;i++){var t=i/160,cr=Math.exp(-Math.pow((t-.38)/.22,2)),X=x0+t*w,Y=y0+h*.78-off-cr*h*(.42-k*.035)+Math.sin(t*9+k)*h*.018;i?x.lineTo(X,Y):x.moveTo(X,Y);}x.stroke();}
    var cx=x0+w*.52,cy=y0+h*.30;
    for(k=0;k<4;k++){x.beginPath();var r0=w*(.16-k*.03);
      for(i=0;i<120;i++){var a=-Math.PI*.2+i/119*Math.PI*1.55,rad=r0*(1-i/119*.55),X2=cx+Math.cos(a)*rad,Y2=cy+Math.sin(a)*rad*.9;i?x.lineTo(X2,Y2):x.moveTo(X2,Y2);}x.stroke();}
    for(i=0;i<14;i++){var a2=r()*Math.PI-Math.PI*.1,rd=w*(.19+r()*.07),q=st*(.8+r()*.9);x.beginPath();x.arc(cx+Math.cos(a2)*rd,cy-Math.abs(Math.sin(a2))*rd*.8,q,0,7);x.fill();}
    x.beginPath();x.arc(x0+w*.80,y0+h*.10,w*.075,0,7);x.stroke();
  }
  function wrapLines(x,text,maxW,maxLines){
    var words=String(text).trim().split(/\s+/),lines=[],cur='';
    words.forEach(function(wd){var t=cur?cur+' '+wd:wd;if(x.measureText(t).width>maxW&&cur){lines.push(cur);cur=wd;}else cur=t;});
    if(cur)lines.push(cur);
    return lines.length>maxLines?null:lines;
  }
  function fitText(x,text,tpl,maxW,maxSize,minSize,maxLines){
    for(var s=maxSize;s>=minSize;s-=1){x.font=font(tpl,s);var l=wrapLines(x,text,maxW,maxLines);if(l&&l.every(function(q){return x.measureText(q).width<=maxW;}))return {size:s,lines:l};}
    x.font=font(tpl,minSize);return {size:minSize,lines:wrapLines(x,text,maxW,99).slice(0,maxLines)};
  }
  function drawText(x,text,cx,top,maxW,maxS,minS,maxLines,tpl){
    var f=fitText(x,text,tpl||SERIF,maxW,maxS,minS,maxLines);x.textAlign='center';x.textBaseline='alphabetic';
    f.lines.forEach(function(l,i){x.fillText(l,cx,top+f.size*(.9+i*1.18));});return f;
  }
  /* ---------- phone case with black frame + wood back ---------- */
  var woodCache={};
  function photoMask(w,h,img,bx,by,bw,bh){
    var c=document.createElement('canvas');c.width=w;c.height=h;var x=c.getContext('2d');
    var iw=img.naturalWidth||img.width,ih=img.naturalHeight||img.height,sc=Math.max(bw/iw,bh/ih),dw=iw*sc,dh=ih*sc;
    x.save();rr(x,bx,by,bw,bh,Math.min(bw,bh)*.08);x.clip();x.drawImage(img,bx+(bw-dw)/2,by+(bh-dh)/2,dw,dh);x.restore();
    var d=x.getImageData(0,0,w,h).data,m=new Float32Array(w*h),i,k,lo=1,hi=0,L=new Float32Array(w*h);
    for(k=0;k<w*h;k++){i=k*4;if(d[i+3]<8){L[k]=-1;continue;}var l=(d[i]*.299+d[i+1]*.587+d[i+2]*.114)/255;L[k]=l;if(l<lo)lo=l;if(l>hi)hi=l;}
    var rg=Math.max(.05,hi-lo);
    for(k=0;k<w*h;k++){if(L[k]<0)continue;var v=1-(L[k]-lo)/rg;v=Math.pow(v,1.15)*.92;var y=(k/w)|0,xx=k%w;var e=Math.min(xx-bx,bx+bw-xx,y-by,by+bh-y)/(Math.min(bw,bh)*.06);m[k]=v*(e<1?Math.max(0,e):1);}
    return m;
  }
  function caseCanvas(W,design,seed,text,photo){
    var H=Math.round(W*960/470),R=W*.16,c=document.createElement('canvas');c.width=W;c.height=H;var x=c.getContext('2d');
    var fg=x.createLinearGradient(0,0,W,H*.4);fg.addColorStop(0,'#3a3b3f');fg.addColorStop(.35,'#1c1d20');fg.addColorStop(1,'#141517');
    rr(x,0,0,W,H,R);x.fillStyle=fg;x.fill();
    rr(x,1.5,1.5,W-3,H-3,R-1.5);x.strokeStyle='rgba(150,150,156,.35)';x.lineWidth=Math.max(1,W/235);x.stroke();
    var pad=Math.round(W*.055),iw=W-2*pad,ih=H-2*pad,ir=R-pad,key=iw+'x'+ih+':'+seed;
    var wd=woodCache[key]||(woodCache[key]=wood(iw,ih,{seed:seed}));
    var s=iw/422,st=Math.max(1.6,5.4*s);
    var m=maskCanvas(iw,ih,function(m){
      if(design==='wolf')wolf(m,iw/2,ih*.56,iw*.74,st);
      if(design==='wave')wave(m,iw*.08,ih*.36,iw*.84,ih*.40,st,seed);
      if(design==='geo')wolf(m,iw/2,ih*.40,iw*.46,st*.85);
      if(design==='wavep')wave(m,iw*.12,ih*.30,iw*.76,ih*.26,st*.9,seed);
      if(text){
        if(design==='photo'){drawText(m,text,iw/2,ih*.70,iw*.78,iw*.11,iw*.05,2);}
        else if(design==='min'){drawText(m,text,iw/2,ih*.40,iw*.80,iw*.2,iw*.06,3);}
        else if(design==='wolf'||design==='wave'){drawText(m,text,iw/2,ih*.80,iw*.6,iw*.085,iw*.05,1);}
        else drawText(m,text,iw/2,ih*.66,iw*.78,iw*.12,iw*.055,3);
      }
    });
    if(photo){var pm=photoMask(iw,ih,photo,iw*.12,ih*.2,iw*.76,ih*.44);for(var q=0;q<pm.length;q++)if(pm[q]>m[q])m[q]=pm[q];}
    var eng=toCanvas(engrave(wd,m,.88));
    x.save();rr(x,pad,pad,iw,ih,ir);x.clip();x.drawImage(eng,pad,pad);
    var sh=x.createLinearGradient(pad,pad,pad+iw,pad+ih);sh.addColorStop(0,'rgba(255,255,255,.10)');sh.addColorStop(.35,'rgba(255,255,255,0)');sh.addColorStop(1,'rgba(0,0,0,.10)');x.fillStyle=sh;x.fillRect(pad,pad,iw,ih);
    x.lineWidth=W*.03;x.strokeStyle='rgba(0,0,0,.22)';rr(x,pad,pad,iw,ih,ir);x.stroke();x.restore();
    /* generic camera window, no lens details */
    var cw=iw*.33,cx0=pad+iw*.065,cy0=pad+iw*.055,lip=W*.022;
    rr(x,cx0-lip,cy0-lip,cw+2*lip,cw+2*lip,cw*.26);x.fillStyle='#18181a';x.fill();
    rr(x,cx0,cy0,cw,cw,cw*.22);var cg=x.createLinearGradient(cx0,cy0,cx0+cw,cy0+cw);cg.addColorStop(0,'#2a2c31');cg.addColorStop(1,'#1f2125');x.fillStyle=cg;x.fill();
    rr(x,cx0+1,cy0+1,cw-2,cw-2,cw*.21);x.strokeStyle='rgba(0,0,0,.55)';x.lineWidth=W*.012;x.stroke();
    return c;
  }
  function plaque(W,H,o){
    var th=Math.round(W*.026),c=document.createElement('canvas');c.width=W;c.height=H+th;var x=c.getContext('2d'),R=W*.03;
    var wd=wood(H,W,{seed:o.seed,light:[232,198,150],dark:[178,124,76],rings:9});
    /* rotate grain to run horizontally */
    var rot=new Uint8ClampedArray(W*H*4),i,j;
    for(j=0;j<H;j++)for(i=0;i<W;i++){var a=(j*W+i)*4,b=((W-1-i)*H+j)*4;rot[a]=wd.data[b];rot[a+1]=wd.data[b+1];rot[a+2]=wd.data[b+2];rot[a+3]=255;}
    var face={w:W,h:H,data:rot};
    var m=maskCanvas(W,H,o.draw);
    var eng=toCanvas(engrave(face,m,.9));
    rr(x,0,th,W,H,R);var eg=x.createLinearGradient(0,th,0,H+th);eg.addColorStop(0,'#a8733f');eg.addColorStop(1,'#7a4c26');x.fillStyle=eg;x.fill();
    x.save();rr(x,0,0,W,H,R);x.clip();x.drawImage(eng,0,0);x.restore();
    rr(x,.5,.5,W-1,H-1,R);x.strokeStyle='rgba(255,240,215,.35)';x.lineWidth=1;x.stroke();
    return c;
  }
  function disc(D,o){
    var th=Math.round(D*.047),c=document.createElement('canvas');c.width=D;c.height=D+th;var x=c.getContext('2d');
    var wd=wood(D,D,{seed:o.seed,light:[236,206,160],dark:[190,136,86],rings:8}),n=noise(D,D,60*D/380,o.seed+9),k=0;
    for(var yy=0;yy<D;yy++)for(var xx=0;xx<D;xx++,k++){var r=Math.sqrt(Math.pow(xx-D*.52,2)+Math.pow(yy-D*.48,2))/D,ring=Math.pow(.5+.5*Math.sin((r*34+(n[k]-.5)*2.2)*Math.PI*2),3),f=1-ring*.16,j=k*4;wd.data[j]*=f;wd.data[j+1]*=f;wd.data[j+2]*=f;}
    var m=maskCanvas(D,D,o.draw),eng=toCanvas(engrave(wd,m,.9));
    x.beginPath();x.ellipse(D/2,D/2+th,D/2,D/2,0,0,7);x.fillStyle='#5c3c24';x.fill();
    x.beginPath();x.ellipse(D/2,D/2,D/2,D/2,0,0,7);x.fillStyle='#543620';x.fill();
    x.save();x.beginPath();x.arc(D/2,D/2,D*.465,0,7);x.clip();x.drawImage(eng,0,0);x.restore();
    return c;
  }
  function placeShadow(x,img,cx,cy,deg,sc,blurPx,offY,alpha){
    x.save();x.translate(cx,cy);x.rotate(deg*Math.PI/180);x.shadowColor='rgba(8,20,36,'+alpha+')';x.shadowBlur=blurPx;x.shadowOffsetY=offY;
    x.drawImage(img,-img.width*sc/2,-img.height*sc/2,img.width*sc,img.height*sc);x.restore();
  }
  function heart(x,hx,hy,hs){x.beginPath();x.moveTo(hx,hy+hs);x.bezierCurveTo(hx-hs*1.3,hy+hs*.1,hx-hs*.9,hy-hs*.9,hx,hy-hs*.25);x.bezierCurveTo(hx+hs*.9,hy-hs*.9,hx+hs*1.3,hy+hs*.1,hx,hy+hs);x.fill();}
  /* ---------- scenes ---------- */
  function sceneCovers(cv){
    var W=cv.width,H=cv.height,x=cv.getContext('2d'),u=W/1000;x.clearRect(0,0,W,H);
    var cw=Math.round(Math.min(350*u,H*.86*470/960)),a=caseCanvas(cw,'wolf',3),b=caseCanvas(cw,'wave',11,cv.getAttribute('data-name')||'');
    placeShadow(x,a,W*.35,H*.47,-7,1,46*u,30*u,.40);
    placeShadow(x,b,W*.66,H*.49,6,1,46*u,30*u,.40);
  }
  function sceneWords(cv){
    var W=cv.width,H=cv.height,x=cv.getContext('2d'),u=W/1000;x.clearRect(0,0,W,H);
    var n1=cv.getAttribute('data-n1')||'Leonardo',n2=cv.getAttribute('data-n2')||'Edoardo',ph=cv.getAttribute('data-phrase')||'Un pensiero per te',dt=cv.getAttribute('data-date')||'';
    var pw=Math.round(560*u),phh=Math.round(270*u);
    var p1=plaque(pw,phh,{seed:21,draw:function(m,w,h){drawText(m,n1,w/2,h*.14,w*.84,h*.42,h*.16,1);if(dt){m.font=font(SERIF_R,h*.12);m.textAlign='center';m.fillText(dt.split('').join(String.fromCharCode(8202)),w/2,h*.86);m.fillRect(w*.3,h*.66,w*.4,Math.max(1.5,h*.008));}}});
    var dd=Math.round(330*u),p2=disc(dd,{seed:33,draw:function(m,w,h){drawText(m,n2,w/2,h*.30,w*.74,h*.2,h*.08,1);heart(m,w/2,h*.70,h*.035);}});
    var p3=plaque(Math.round(440*u),Math.round(140*u),{seed:45,draw:function(m,w,h){drawText(m,ph,w/2,h*.2,w*.86,h*.36,h*.16,1);}});
    placeShadow(x,p2,W*.76,H*.26,8,1,40*u,26*u,.34);
    placeShadow(x,p1,W*.36,H*.52,-4,1,40*u,26*u,.34);
    placeShadow(x,p3,W*.66,H*.82,4,1,36*u,22*u,.32);
  }
  function scenePreview(cv,text,style,photo){
    var W=cv.width,H=cv.height,x=cv.getContext('2d');x.clearRect(0,0,W,H);
    var cw=Math.round(Math.min(W*.78,H*.86*470/960)),d=photo?'photo':style==='geometrico'?'geo':style==='onda'?'wavep':'min';
    var c=caseCanvas(cw,d,style==='onda'?11:3,text||' ',photo);
    placeShadow(x,c,W/2,H/2,-3,1,cw*.09,cw*.06,.38);
  }
  function scenePlaque(cv,text,sub){
    var W=cv.width,H=cv.height,x=cv.getContext('2d');x.clearRect(0,0,W,H);
    var pw=Math.round(Math.min(W*.86,H*.86*2.05)),ph=Math.round(pw/2.05);
    var p=plaque(pw,ph,{seed:21,draw:function(m,w,h){var f=drawText(m,text||' ',w/2,h*(sub?.12:.2),w*.84,h*.4,h*.1,2);if(sub){m.font=font(SERIF_R,h*.11);m.textAlign='center';m.fillText(sub,w/2,h*.88);m.fillRect(w*.32,h*.70,w*.36,Math.max(1.5,h*.008));}}});
    placeShadow(x,p,W/2,H/2,-3,1,pw*.06,pw*.04,.36);
  }
  var SC={covers:sceneCovers,words:sceneWords};
  function size(cv){var r=cv.getBoundingClientRect(),dpr=Math.min(2,window.devicePixelRatio||1),ar=(r.width&&r.height)?r.width/r.height:(parseFloat(cv.getAttribute('data-ar'))||1);var w=Math.max(280,Math.round(r.width*dpr));cv.width=Math.min(w,1100);cv.height=Math.round(cv.width/ar);}
  function render(cv){try{size(cv);SC[cv.getAttribute('data-scene')](cv);cv.classList.add('is-ready');}catch(e){}}
  window.GLaser={plaque:function(cv,text,sub){try{size(cv);scenePlaque(cv,text,sub);cv.classList.add('is-ready');}catch(e){}},render:render,preview:function(cv,text,style,photo){try{size(cv);scenePreview(cv,text,style,photo);cv.classList.add('is-ready');}catch(e){}}};
})();
